import React from "react";
import { createPortal } from "react-dom";

/**
 * Action row for a form section.
 * Pass a DOM node as `host` to pin the row in a modal footer.
 * `host={null}` renders nothing (section is inactive or the host is not ready).
 * Omit `host` to render the row inline under the section.
 * `leading` renders on the left (for example, Back); `children` stay on the right.
 */
const SectionFooter = ({ host, leading, children }) => {
    const row = (
        <div className="flex w-full flex-wrap items-center justify-between gap-3">
            {leading ? <div className="flex flex-wrap items-center gap-3">{leading}</div> : null}
            <div className="ml-auto flex flex-wrap items-center justify-end gap-3">
                {children}
            </div>
        </div>
    );

    if (host) return createPortal(row, host);
    if (host === null) return null;

    return (
        <div className="mt-6 border-t border-gray-200 bg-white pt-4">
            {row}
        </div>
    );
};

export default SectionFooter;
